import React from 'react';
import ButtonInc from '../../../../../../shared-ui/ButtonInc';
import { getPartner } from '../../../../../../lib/access.es6';
import PolicyInfoHeader from '../../shared/Components/PolicyInfoHeader';
import AmendmentPageHeader from '../../shared/Components/AmendmentPageHeader';

/**
 * Screen displaying all policy members with edit buttons
 */
const MemberListScreen = ({ members, policy, onEditMember, onCancel }) => {
  const currencyCode = getPartner().country.currency_code;

  // Calculate total premium
  const totalPremium = members.reduce((sum, m) => sum + (m.premium_amount_in_cents || 0), 0);

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      {/* Header */}
      <AmendmentPageHeader
        title="Modify Member Details"
        subtitle="Select a member to update their personal information"
        onBack={onCancel}
      />

      {/* Policy Information */}
      <PolicyInfoHeader policy={policy} showTotalPremium={true} totalPremium={totalPremium} />

      {/* Members Table */}
      <div style={{ marginBottom: '30px' }}>
        <table style={{
          width: '100%',
          background: '#FFFFFF',
          border: '1px solid #A7A7A7',
          borderCollapse: 'collapse'
        }}>
          <thead>
            <tr style={{ backgroundColor: '#f8f9fa', borderTop: '1px solid #A7A7A7' }}>
              <th style={{
                fontFamily: 'Lato',
                fontWeight: 700,
                fontSize: '12px',
                color: '#000000',
                padding: '10px',
                borderRight: '1px solid #A7A7A7',
                textAlign: 'left'
              }}>
                Member Name
              </th>
              <th style={{
                fontFamily: 'Lato',
                fontWeight: 700,
                fontSize: '12px',
                color: '#000000',
                padding: '10px',
                borderRight: '1px solid #A7A7A7'
              }}>
                Relationship
              </th>
              <th style={{
                fontFamily: 'Lato',
                fontWeight: 700,
                fontSize: '12px',
                color: '#000000',
                padding: '10px',
                borderRight: '1px solid #A7A7A7'
              }}>
                National ID
              </th>
              <th style={{
                fontFamily: 'Lato',
                fontWeight: 700,
                fontSize: '12px',
                color: '#000000',
                padding: '10px',
                borderRight: '1px solid #A7A7A7'
              }}>
                Phone
              </th>
              <th style={{
                fontFamily: 'Lato',
                fontWeight: 700,
                fontSize: '12px',
                color: '#000000',
                padding: '10px',
                borderRight: '1px solid #A7A7A7',
                textAlign: 'right'
              }}>
                Premium
              </th>
              <th style={{
                fontFamily: 'Lato',
                fontWeight: 700,
                fontSize: '12px',
                color: '#000000',
                padding: '10px',
                borderRight: '1px solid #A7A7A7',
                textAlign: 'center'
              }}>
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {members.map((member, index) => (
              <tr key={member.uuid || index} style={{ borderTop: '1px solid #A7A7A7' }}>
                <td style={{
                  fontFamily: 'open sans',
                  fontSize: '12px',
                  color: '#000000',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7'
                }}>
                  {member.first_name} {member.middle_name ? member.middle_name + ' ' : ''}{member.last_name}
                </td>
                <td style={{
                  fontFamily: 'open sans',
                  fontSize: '12px',
                  color: '#000000',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7',
                  textAlign: 'center'
                }}>
                  {member.relationship}
                </td>
                <td style={{
                  fontFamily: 'open sans',
                  fontSize: '12px',
                  color: '#000000',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7',
                  textAlign: 'center'
                }}>
                  {member.national_id && member.national_id !== 'N/A' ? member.national_id : '-'}
                </td>
                <td style={{
                  fontFamily: 'open sans',
                  fontSize: '12px',
                  color: '#000000',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7',
                  textAlign: 'center'
                }}>
                  {member.msisdn && member.msisdn !== 'N/A' ? member.msisdn : '-'}
                </td>
                <td style={{
                  fontFamily: 'open sans',
                  fontSize: '12px',
                  color: '#000000',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7',
                  textAlign: 'right',
                  fontWeight: '600'
                }}>
                  {currencyCode} {((member.premium_amount_in_cents || 0) / 100).toFixed(2)}
                </td>
                <td style={{
                  fontFamily: 'open sans',
                  fontSize: '12px',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7',
                  textAlign: 'center'
                }}>
                  <ButtonInc
                    style={{ cursor: 'pointer', padding: '5px 15px' }}
                    onClick={() => onEditMember(member)}
                  >
                    Edit
                  </ButtonInc>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
};

export default MemberListScreen;
